/**
 * Button logic component
 *
 * Provides all the logic to create styled button with loading, disabled state
 */
import React from 'react';
import { pickStyles } from 'utils/styles';
import { Styles } from 'utils/types/react';

interface Props {
  disabled?: boolean;
  loading?: boolean;
  onClick?: Function;
  style?: Styles;
}

export function useButton<AdditionalProps>({
  onClick,
  style,
  disabled = false,
  loading = false,
  ...props
}: Props & AdditionalProps) {
  const [isLoading, setLoading] = React.useState(loading);

  React.useEffect(() => {
    setLoading(loading);
  }, [loading]);

  function onClickHandler(...params) {
    if (!isLoading && !disabled) {
      if (onClick) {
        onClick(...params);
      }
    }
  }

  // When we are extending button styles we want to set color, fontSize or fontFamily directly on Button component and have better DX
  const labelStyles = pickStyles(
    style,
    'color',
    'fontSize',
    'fontFamily',
    'fontWeight',
  );

  return {
    ...props,
    style,
    loading,
    setLoading,
    labelStyles,
    disabled: Boolean(disabled) || loading,
    onClick: onClickHandler,
  };
}
